import { useCallback } from "react";

import { BodyCell, PercentBodyCell } from "../../../../components/SharedComponents/sharedComponents.index";

import PropTypes from 'prop-types';

import { TABLE_TYPE } from "../../../../components/components.constants";

export function BodyCells({ ctx, uiState }) {

  const { 
    columns, 
    prediction, 
    productIds, 
    monthIndex, 
    individualProduct = false,
    table = "" 
  } = ctx || {};

  const { 
    forecastColumnsBorders, 
    headerHeight, 
    cellTopBorder 
  } = uiState || {};

  const defineLeftCellBorder = useCallback((columnIndex) => {
    return columnIndex === 0 && (productIds?.length !== 0 || monthIndex !== 0);
  }, [productIds, monthIndex]);

  if(table === TABLE_TYPE.ACCURACY) {
    const {
      officialClientPrediction,
      officialAidronPrediction,
      realized,
      participationInRealized,
      percentOfficialAidronVsRealized,
      percentOfficialClientVsRealized
    } = prediction || {};

    return (
      productIds.length > 0 &&
      columns.map((column, index) => {
        const shouldShowLeftBorder = forecastColumnsBorders 
          ? forecastColumnsBorders[index] 
          : defineLeftCellBorder(monthIndex, index);

        return (
          <td
            className={`text-center background-color-white ${shouldShowLeftBorder ? "cell-left-border" : ""} ${
              individualProduct ? "" : "position-sticky cell-bottom-border z-1"
            } ${cellTopBorder ? "cell-top-border" : ""}`}
            style={{ top: individualProduct ? "" : `${headerHeight}px` }}
            key={`label-${column.label}`}
          >
            {(column.type === 'demand') && <BodyCell prediction={officialClientPrediction} />}

            {(column.type === 'prediction') && <BodyCell prediction={officialAidronPrediction} />}

            {(column.type === 'realized') && <BodyCell prediction={realized} />}

            {column.type === "%" && 
              <PercentBodyCell 
                ctx={{ prediction: participationInRealized }}
                uiState={{ enablePercentualValue: true }}/>}

            {column.type === "dif%" && 
              <PercentBodyCell 
                ctx={{ prediction: percentOfficialAidronVsRealized }}
                uiState={{ showFlag: true, enablePercentualValue: true }}/>}

            {column.type === "dif" && (
              <PercentBodyCell
                ctx={{ prediction: percentOfficialClientVsRealized }}
                uiState={{
                  showFlag: true,
                  enablePercentualValue: true,
                  predictionForFlagColor: percentOfficialAidronVsRealized
                }}
              />
            )}
          </td>
        );
      })
    );
  }

  const {
    aidronPrediction,
    clientPrediction,
    participationInAidron,
    participationInRealized,
    percentAidronVsClient,
    differenceAidronAndClient,
    realized
  } = prediction || {};

  return (
    productIds.length > 0 && columns.map((column, index) => {
      const shouldShowLeftBorder = forecastColumnsBorders ? forecastColumnsBorders[index] : defineLeftCellBorder(monthIndex, index);

      return (
        <td
          className={`text-center background-color-white ${shouldShowLeftBorder ? "cell-left-border" : ""} ${
            individualProduct ? "" : "position-sticky cell-bottom-border z-1"
          } ${cellTopBorder ? "cell-top-border" : ""}`}
          style={{ top: individualProduct ? "" : `${headerHeight}px` }}
          key={`label-${column.label}`}
        >
          {(column.type === 'demand') && <BodyCell prediction={clientPrediction} />}

          {(column.type === 'prediction') && <BodyCell prediction={aidronPrediction} />}

          {(column.type === 'realized') && <BodyCell prediction={realized} />}

          {column.type === "%" && 
            <PercentBodyCell 
              ctx={{ prediction: participationInAidron }}
              uiState={{ enablePercentualValue: true }}/>
          }

          {column.type === "participationInRealized" && 
            <PercentBodyCell 
              ctx={{ prediction: participationInRealized }}
              uiState={{ enablePercentualValue: true }}/>
          }

          {column.type === "dif%" && 
            <PercentBodyCell 
                ctx={{ prediction: percentAidronVsClient }}
                uiState={{ showFlag: true, enablePercentualValue: true }}/>}

          {column.type === "dif" && (
            <PercentBodyCell
              ctx={{ prediction: differenceAidronAndClient }}
              uiState={{
                showFlag: true,
                enablePercentualValue: false,
                predictionForFlagColor: percentAidronVsClient
              }}
            />
          )}
        </td>
      );
    })
  );
};

BodyCells.propTypes = {
  ctx: PropTypes.shape(),
  uiState: PropTypes.shape()
};